import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { fetchPositions } from '../../../apis/personnelApi';
import {ITimesheetTable} from '../../../interface/Personnel'
export const useFetchPositions = (
  personalId: number
) => {
  return useQuery<{ data: ITimesheetTable[]; totalItems: number }, Error>(
    ['sites'],
    () => fetchPositions(personalId),
    {
      keepPreviousData: true,
      onError: (error) => {
        toast.error(error.message || 'An unexpected error occurred while fetching positions.');
      },
    }
  );
};
